import { GravityFormProvider } from '../../hooks/GFormsHooks';
import { GF_Form } from '../../model/gforms/gform';
import GFormsForm from './GFormsForm';

import './GForm.css';

interface Props {
  form: GF_Form;
}

export default function GForm(props: Props) {
  return (
    <GravityFormProvider>
      <GFormsForm {...props} />
    </GravityFormProvider>
  );
}
